import { render } from "./ChatInterface.vue?vue&type=template&id=34c9aea2"
import script from "./ChatInterface.vue?vue&type=script&lang=js"
export * from "./ChatInterface.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__